import { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  direction: 'bottom' | 'top'
  height: number
}
const GradientShadow: FC<Props> = ({ direction, height }) => (
  <Box.Motion
    initial={{ opacity: 0 }}
    exit={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    style={{
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      height: `${height}px`,
      background: `linear-gradient(to ${direction}, #fff 0%, #00000000 20%)`,
      pointerEvents: 'none',
      zIndex: '100',
    }}
  ></Box.Motion>
)

export default GradientShadow
